import React, { useEffect, useState } from "react";
import { api, formatCurrency } from "../lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { PageHeader } from "./Dashboard";
import { FileSpreadsheet, FileText, Download, Database } from "lucide-react";

export default function Exports() {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    api.analytics().then((r) => setSummary(r.data)).catch(() => {});
  }, []);

  const ExportCard = ({ title, desc, icon: Icon, onClick, testid, accent }) => (
    <Card className="transition-[box-shadow,border-color] duration-200 hover:shadow-sm">
      <CardContent className="p-6 flex flex-col items-start">
        <div className={`flex h-12 w-12 items-center justify-center rounded-xl ${accent} mb-4`}>
          <Icon className="h-6 w-6" />
        </div>
        <div className="font-heading font-semibold">{title}</div>
        <p className="mt-1 text-sm text-muted-foreground">{desc}</p>
        <Button className="mt-4 gap-2" data-testid={testid} onClick={onClick}>
          <Download className="h-4 w-4" /> Download
        </Button>
      </CardContent>
    </Card>
  );

  return (
    <div className="space-y-6">
      <PageHeader title="Exports" subtitle="Download your extracted toll-bill data for accounting & reconciliation" />

      {summary && (
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-semibold flex items-center gap-2"><Database className="h-4 w-4 text-muted-foreground" /> What will be exported</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
              <Stat label="Bills" value={summary.total_bills} />
              <Stat label="Transactions" value={summary.total_transactions} />
              <Stat label="Authorities" value={(summary.by_authority || []).length} />
              <Stat label="Total due" value={formatCurrency(summary.total_amount_due)} />
            </div>
          </CardContent>
        </Card>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <ExportCard
          title="Export to CSV"
          desc="A flat CSV of all extracted bills with totals, dates, plates and authorities."
          icon={FileText}
          accent="bg-sky-50 text-sky-700"
          testid="export-csv-button"
          onClick={() => window.open(api.exportCsvUrl(), "_blank")}
        />
        <ExportCard
          title="Export to Excel"
          desc="An .xlsx workbook with two sheets: Bills and individual Transactions."
          icon={FileSpreadsheet}
          accent="bg-emerald-50 text-emerald-700"
          testid="export-excel-button"
          onClick={() => window.open(api.exportExcelUrl(), "_blank")}
        />
      </div>
    </div>
  );
}

const Stat = ({ label, value }) => (
  <div>
    <div className="text-xs text-muted-foreground uppercase tracking-wide">{label}</div>
    <div className="mt-1 text-xl font-semibold font-heading tabular-nums">{value}</div>
  </div>
);
